const NETWORK_QUALIFIED_CURRENCIES = new Set(['USDT', 'USDC']);

export const getWithdrawalMethod = (coin, network) => {
  const currencyCode = coin.toUpperCase();
  return NETWORK_QUALIFIED_CURRENCIES.has(currencyCode)
    ? `${currencyCode}_${network}`
    : currencyCode;
};

const getValidationField = (error) => error?.path || error?.param;

export const getWithdrawalErrorMessage = (error) => {
  const responseData = error?.response?.data;
  const validationErrors = Array.isArray(responseData?.errors)
    ? responseData.errors
    : [];
  const responseMessage = responseData?.message;
  const hasTransactionPasswordValidationError = validationErrors.some(
    (validationError) =>
      getValidationField(validationError) === 'transactionPassword'
  );
  const hasExplicitInvalidPasswordResponse =
    typeof responseMessage === 'string' &&
    responseMessage.trim().toLowerCase() ===
      'invalid transaction password. please try again.';

  if (
    hasExplicitInvalidPasswordResponse ||
    hasTransactionPasswordValidationError
  ) {
    return 'Fund password not match. Please enter the correct fund password.';
  }

  const validationMessage = validationErrors.find(
    (validationError) =>
      typeof validationError?.msg === 'string' && validationError.msg.trim()
  )?.msg;

  return (
    validationMessage ||
    responseMessage ||
    (typeof responseData?.error === 'string' && responseData.error) ||
    error?.message ||
    'Failed to submit withdrawal request'
  );
};
